import { replaceRoutes } from '@/router/dynamicRoutes';
import { RouteOption } from '@/router/interface';
const presetList = [
    // {
    //   id: 1,
    //   name: 'workplace',
    //   title: '工作台',
    //   icon: 'DashboardOutlined',
    //   badge: 'new',
    //   target: '_self',
    //   path: '/workplace',
    //   component: '@/pages/workplace',
    //   renderMenu: true,
    //   parent: null,
    //   permission: null,
    //   cacheable: true,
    // },
    // {
    //   id: 2,
    //   name: 'table',
    //   title: '表格',
    //   icon: 'TableOutlined',
    //   badge: '',
    //   target: '_self',
    //   path: '/table',
    //   component: '@/pages/table',
    //   renderMenu: true,
    //   parent: null,
    //   permission: null,
    //   cacheable: true,
    // },
    // {
    //   id: 3,
    //   name: 'personal',
    //   title: '个人中心',
    //   path: '/personal',
    //   icon: 'ProfileOutlined',
    //   permission: null,
    //   component: '@/pages/personal',
    //   renderMenu: true,
    //   parent: null,
    // },
    // {
    //   id: 6,
    //   name: 'system',
    //   title: '系统配置',
    //   icon: 'SettingOutlined',
    //   badge: '',
    //   target: '_self',
    //   path: '/system',
    //   component: '@/components/layout/BlankView.vue',
    //   renderMenu: true,
    //   parent: null,
    //   permission: null,
    //   cacheable: true,
    // },
    // {
    //   id: 8,
    //   name: 'menu',
    //   title: '菜单管理',
    //   badge: '12',
    //   target: '_self',
    //   path: '/system/menu',
    //   component: '@/pages/system',
    //   renderMenu: true,
    //   parent: 'system',
    //   permission: null,
    //   cacheable: true,
    // },
    // {
    //   id: 7,
    //   name: 'user',
    //   title: '用户管理',
    //   target: '_self',
    //   path: '/system/user',
    //   component: '@/pages/user',
    //   renderMenu: true,
    //   parent: 'system',
    //   permission: null,
    //   cacheable: true,
    // },
    {
      id: 9,
      name: 'meal',
      title: '套餐中心',
      icon: 'SettingOutlined',
      badge: '',
      target: '_self',
      path: '/meal',
      component: '@/components/layout/BlankView.vue',
      renderMenu: true,
      parent: null,
      permission: null,
      cacheable: true,
    },
    {
      id: 10,
      name: 'mealList',
      title: '套餐列表',
      target: '_self',
      path: '/meal/list',
      component: '@/pages/meal',
      renderMenu: true,
      parent: 'meal',
      permission: null,
      cacheable: true,
    },
  ];
  export interface MenuProps {
    id?: number;
    name: string;
    path: string;
    title?: string;
    icon?: string;
    badge?: number | string;
    target?: '_self' | '_blank';
    link?: string;
    component: string;
    renderMenu?: boolean;
    permission?: string;
    parent?: string;
    children?: MenuProps[];
    cacheable?: boolean;
    view?: string;
  }
  function getMenuList() {
    const menuStr = localStorage.getItem('stepin-menu');
    let menuList = [];
    if (!menuStr) {
      menuList = presetList;
      localStorage.setItem('stepin-menu', JSON.stringify(menuList));
    } else {
      menuList = JSON.parse(menuStr);
    }
    return menuList;
  }

  const baseRouterList = () => {
    let menuList = getMenuList();
    const menuMap = menuList.reduce((p, c) => {
        p[c.name] = c;
        return p;
    }, {});
    console.log(menuList,'menuList');
    
    menuList.forEach((menu) => {
        menu.renderMenu = !!menu.renderMenu;
        if (menu.parent) {
        const parent = menuMap[menu.parent];
        parent.children = parent.children ?? [];
        parent.children.push(menu);
        }
    });
    const data = menuList.filter((menu) => !menu.parent)
    replaceRoutes(toRoutes(data), false);
    return 
  }
const toRoutes = (list: MenuProps[]): RouteOption[] => {
  return list.map((item) => ({
    name: item.name,
    path: item.path,
    component: item.component,
    children: item.children && toRoutes(item.children),
    meta: {
      title: item.title,
      permission: item.permission,
      icon: item.icon,
      renderMenu: item.renderMenu,
      cacheable: item.cacheable,
      href: item.link,
      badge: /^(false|true)$/i.test(item.badge + '') ? JSON.parse(item.badge + '') : item.badge,
      target: item.target,
      view: item.view,
    },
  }));
};
  export default baseRouterList